import { render, staticRenderFns } from "./AppTimelineItem.vue?vue&type=template&id=b938a032&scoped=true&"
import script from "./AppTimelineItem.vue?vue&type=script&lang=js&"
export * from "./AppTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTimelineItem.vue?vue&type=style&index=0&id=b938a032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938a032",
  null
  
)

export default component.exports